// Site-wide text translation keyed by the Mongolian source string.
//
// Components call tr('Монгол текст'); the dictionary for the chosen language maps
// that text to its translation, and anything missing falls back to Mongolian. The
// dictionary is loaded before the app's modules evaluate (see index.js), so
// module-level labels translate too; changing language reloads the page.
export const LANGUAGE_CODES = ['mn', 'en', 'zh'];
export const STORAGE_KEY = 'mba-language';

let dictionary = {};

export function currentLanguage() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return LANGUAGE_CODES.includes(saved) ? saved : 'mn';
  } catch {
    return 'mn';
  }
}

export async function initI18n() {
  const lang = currentLanguage();
  if (lang === 'mn') return lang;
  try {
    dictionary = (await import(`../translations/strings.${lang}.json`)).default;
  } catch {
    dictionary = {};
  }
  return lang;
}

// tr('{0} тоглогч', n): numbered placeholders are filled after translation, so a
// language can reorder them.
export const tr = (text, ...args) => {
  const out = dictionary[text] ?? text;
  return args.length ? out.replace(/\{(\d+)\}/g, (m, i) => (args[i] === undefined ? m : String(args[i]))) : out;
};


export function changeLanguage(lang) {
  if (!LANGUAGE_CODES.includes(lang) || lang === currentLanguage()) return;
  try { localStorage.setItem(STORAGE_KEY, lang); } catch { /* storage unavailable */ }
  window.location.reload();
}
